(function () {
  var config = window.orderLimitConfig || { messages: {}, collectionLimits: {} };
  var defaultMessages = {
    min: '[product] requires a minimum order quantity of [min].',
    max: '[product] has a maximum order quantity of [max].',
    global_max: 'You can order a maximum of [max] total units of [product] per order.',
    collection_max: 'You can order a maximum of [max] total units from the [collection] collection per order.'
  };
  var messages = Object.assign({}, defaultMessages, config.messages || {});
  var collectionLimits = config.collectionLimits || {};

  function format(template, vars) {
    return template.replace(/\[(\w+)\]/g, function (_, key) {
      return vars[key] !== undefined ? vars[key] : '';
    });
  }

  function readRow(row) {
    var input = row.querySelector('input[type="number"]');
    var maxAttr = row.getAttribute('data-max-order-qty');
    var globalMaxAttr = row.getAttribute('data-global-max-qty');
    return {
      quantity: input ? parseInt(input.value, 10) || 0 : 0,
      title: row.getAttribute('data-product-title') || 'This product',
      min: parseInt(row.getAttribute('data-min-order-qty'), 10) || 0,
      max: maxAttr ? parseInt(maxAttr, 10) : null,
      globalMax: globalMaxAttr ? parseInt(globalMaxAttr, 10) : null,
      productId: row.getAttribute('data-product-id'),
      collectionHandles: (row.getAttribute('data-collection-handles') || '').split(',').filter(Boolean)
    };
  }

  function validate(root) {
    var rows = Array.prototype.slice
      .call(root.querySelectorAll('[data-order-limit-row]'))
      .map(readRow)
      .filter(function (r) {
        return r.quantity > 0;
      });

    var errors = [];

    rows.forEach(function (r) {
      if (r.min && r.quantity < r.min) {
        errors.push(format(messages.min, { product: r.title, min: r.min, quantity: r.quantity }));
      }
      if (r.max !== null && r.quantity > r.max) {
        errors.push(format(messages.max, { product: r.title, max: r.max, quantity: r.quantity }));
      }
    });

    var productTotals = {};
    var productMeta = {};
    rows.forEach(function (r) {
      productTotals[r.productId] = (productTotals[r.productId] || 0) + r.quantity;
      productMeta[r.productId] = r;
    });
    Object.keys(productTotals).forEach(function (productId) {
      var r = productMeta[productId];
      if (r.globalMax !== null && productTotals[productId] > r.globalMax) {
        errors.push(format(messages.global_max, { product: r.title, max: r.globalMax, quantity: productTotals[productId] }));
      }
    });

    var collectionTotals = {};
    rows.forEach(function (r) {
      r.collectionHandles.forEach(function (handle) {
        if (collectionLimits[handle]) {
          collectionTotals[handle] = (collectionTotals[handle] || 0) + r.quantity;
        }
      });
    });
    Object.keys(collectionTotals).forEach(function (handle) {
      var limit = collectionLimits[handle];
      if (collectionTotals[handle] > limit.max) {
        errors.push(format(messages.collection_max, { collection: limit.name, max: limit.max, quantity: collectionTotals[handle] }));
      }
    });

    return errors;
  }

  function setButtonsDisabled(root, disabled) {
    var buttons = root.querySelectorAll('#checkout, #CartDrawer-Checkout, .additional-checkout-buttons, .shopify-payment-button, #dynamic-checkout-cart');
    buttons.forEach(function (el) {
      if (disabled) {
        el.setAttribute('disabled', 'disabled');
        el.classList.add('order-limit-blocked');
      } else {
        el.removeAttribute('disabled');
        el.classList.remove('order-limit-blocked');
      }
    });
  }

  function showErrors(root, errors) {
    var container = root.querySelector('[data-order-limit-errors]');
    if (!container) return;
    if (errors.length) {
      container.innerHTML = '<span class="cart-item__error-text">' + errors.join('<br>') + '</span>';
      container.classList.remove('hidden');
    } else {
      container.innerHTML = '';
      container.classList.add('hidden');
    }
  }

  function correctSilentStepDrift(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-order-limit-row]'), function (row) {
      var input = row.querySelector('input[type="number"]');
      if (!input || input.dataset.orderLimitCorrecting) return;
      var renderedValue = input.getAttribute('value') || '0';
      if (input.value !== '' && input.value !== renderedValue) {
        input.dataset.orderLimitCorrecting = 'true';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function runValidation(root) {
    correctSilentStepDrift(root);
    var errors = validate(root);
    showErrors(root, errors);
    setButtonsDisabled(root, errors.length > 0);
    return errors.length === 0;
  }

  function validateAllScopes() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-order-limit-scope]'), runValidation);
  }

  var pending = null;
  function scheduleValidation() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      validateAllScopes();
    }, 50);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[type="number"]')) {
      scheduleValidation();
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      var checkoutBtn = e.target.closest('#checkout, #CartDrawer-Checkout');
      if (!checkoutBtn) return;
      var root = checkoutBtn.closest('[data-order-limit-scope]');
      if (root && !runValidation(root)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  var observer = new MutationObserver(scheduleValidation);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateAllScopes);
  } else {
    validateAllScopes();
  }
})();
